// extracted by mini-css-extract-plugin
module.exports = {"pin":"styles_pin__xPLFr","pinImage":"styles_pinImage__gKt5S"};